module.exports = __webpack_public_path__ + "static/media/metro.d0946cba.jpg";